import React from 'react'
import cx from 'classnames'
import styles from './style.module.sass'

export default ({ children, classes, id }) => (
  <div className={cx(styles.block, classes)} id={id}>
    {children}
  </div>
)
